// Common response handler for fetch-based APIs
export async function handleResponse(res, defaultMsg) {
  if (res.status === 403) {
    window.location.href = '/';
    throw new Error('Forbidden'); // stop further processing
  }
  if (!res.ok) {
    let errorMsg = defaultMsg;
    try {
      const errorBody = await res.json();
      errorMsg = errorBody.error || defaultMsg;
    } catch {}
    throw new Error(errorMsg);
  }
  return res.json();
}
